




















import Vue from 'vue'
import _ from 'lodash'
import dynPlaceholder from '../dynPlaceholder.vue'
export default Vue.extend({
  name: 'UiInput',
  components: {dynPlaceholder},
  props: {
    name: {},
    value: String,
    placeholder: {},
    suffixIcon: {},
    readOnly: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    type: {type: String, default: 'text'},
    rows: Number,
    error: Boolean,
    hideDynPlaceholder: Boolean
  },
  methods: {
    onFocus (event: UIEvent) {
      // @ts-ignore
      this.$emit('focus', _.trim(event as string))
    },
    onBlur (event: UIEvent) {
      // @ts-ignore
      this.$emit('blur', _.trim(event as string))
    },
    onInput (event: string) {
      // @ts-ignore
      this.$emit('input', _.trim(event as string))
    }
  },
  computed: {
    currentValue: {
      get (): string {
        return this.value || ''
      },
      set () {
      }
    },
    showDynPldr (): boolean {
      return !!this.currentValue || this.error
    }
  }
})
